import PropTypes from 'prop-types'

import GreyDot from './GreyDot'
import RedDot from './RedDot'
import TealDot from './TealDot'

const CustomDot = ({ cx, cy, value }) => {
  if (value === null) {
    return <GreyDot cx={cx} cy={cy} />
  }

  if (value < 0) {
    return <RedDot cx={cx} cy={cy} />
  }

  return <TealDot cx={cx} cy={cy} />
}

CustomDot.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  value: PropTypes.number
}

CustomDot.defaultProps = {
  cx: 0,
  cy: 0,
  value: 0
}

export default CustomDot
